/*@ngInject*/
const UISnippetsViewerDraggableDirective = function ($document, $window, $timeout, $stateParams, submissionStateMediator) {

    var linkFunction = function ($scope, $elm, $attrs) {

        var opt = {
            handle: '.snippetsViewerHeader',
            draggableClass: 'draggable',
            activeHandleClass: 'active-handle'
        };

        var lastPosition = {};
        var $selected = null;
        var $handle = $elm.find(opt.handle);
        var elementSize = {
            width: null,
            height: null
        };

        var saveState = function () {
            var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};

            currentState = _.extend(currentState, lastPosition);

            submissionStateMediator.saveSnippetsViewerPositionState($stateParams.submissionId, currentState);
        };

        var restoreState = function () {
            var currentState = submissionStateMediator.getSnippetsViewerPositionState($stateParams.submissionId) || {};

            lastPosition = {
                top: _.get(currentState, 'top', ''),
                left: _.get(currentState, 'left', '')
            };
        };

        var setElementPosition = function (top, left) {
            var offset = 200;
            if (top < -offset) {
                top = -offset;
            }
            if (left < -offset) {
                left = -offset;
            }

            var maxTop = $window.innerHeight - elementSize.height + offset;
            var maxLeft = $window.innerWidth - elementSize.width + offset;

            if (top > maxTop) {
                top = maxTop;
            }
            if (left > maxLeft) {
                left = maxLeft;
            }

            $elm.offset({
                top: top,
                left: left
            });
            lastPosition.top = top;
            lastPosition.left = left;
        };

        var centerElement = function () {
            $elm.removeClass('isDetached');
            $timeout(function () {
                var left = ($($window).width() / 2) - ($elm.width() / 2);
                var top = ($($window).height() / 2) - ($elm.height() / 2);
                setElementPosition(top, left);
            }, 1); //delay so the dom has time to update the height/width
        };

        var handleMousedown = function (e) {
            if (!$scope.$ctrl.isDetached) {
                return;
            }

            $elm.addClass(opt.draggableClass);
            $handle.addClass(opt.activeHandleClass);

            elementSize.width = $elm.width();
            elementSize.height = $elm.height();

            var drgH = $elm.outerHeight(),
                drgW = $elm.outerWidth(),
                posY = $elm.offset().top + drgH - e.pageY,
                posX = $elm.offset().left + drgW - e.pageX;

            var top = e.pageY + posY - drgH,
                left = e.pageX + posX - drgW;

            $document.on('mousemove', function (e) {
                var top = e.pageY + posY - drgH < 0 ? 0 : e.pageY + posY - drgH,
                    left = e.pageX + posX - drgW < 0 ? 0 : e.pageX + posX - drgW;

                setElementPosition(top, left);
            });
            $document.on('mouseup', function () {
                $document.off('mousemove'); // Unbind events from document
                $elm.removeClass(opt.draggableClass);
            });
            e.preventDefault(); // disable selection
        };

        var handleMouseup = function () {
            if (!$scope.$ctrl.isDetached) {
                return;
            }
            $elm.removeClass(opt.draggableClass);
            $handle.removeClass(opt.activeHandleClass);

            $selected = null;

            saveState();
        };

        $handle.on('mousedown', handleMousedown);
        $handle.on('mouseup', handleMouseup);

        $scope.$watch('$ctrl.isDetached', function (newValue) {
            if (newValue) {
                if (!_.isEmpty(lastPosition)) {
                    $elm.offset(lastPosition);
                } else {
                    centerElement();
                }
            } else {
                $elm.css({'top': '', 'left': ''});
            }

            saveState();
        });

        $scope.$on('$destroy', function () {
            $handle.off('mousedown', handleMousedown);
            $handle.off('mouseup', handleMouseup);
        });

        restoreState();
    };

    return {
        restrict: 'A',
        replace: false,
        link: linkFunction
    };
};

angular.module('gw-um-submission')
    .directive('uiSnippetsViewerDraggable', UISnippetsViewerDraggableDirective);
